<template>
    <div class="modal fade" :class="{ show: isVisible }" tabindex="-1" style="display: block;" aria-modal="true"
        role="dialog" v-if="isVisible">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content shadow-lg border-0 rounded-4">
                <div class="modal-header border-0">
                    <!-- <h5 class="modal-title text-primary fw-bold">Convert Opportunity</h5> -->
                    <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center px-5">
                    <i class="bi bi-question-circle-fill text-warning display-4 mb-3"></i>
                    <h4 class="fw-semibold mb-3">Are you sure you want to convert this opportunity?</h4>
                    <p class="text-muted mb-4">This action might affect your pipeline.</p>
                    <div class="d-flex justify-content-center gap-3">
                        <button class="btn btn-danger px-4" @click="handleConfirm">
                            Yes, Convert
                        </button>
                        <button class="btn btn-outline-secondary px-4" @click="closeModal">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    watch,
    onUnmounted,
} from "vue";
export default {
    props: {
        isVisible: {
            type: Boolean,
        }
    },
    setup(props, {
        emit
    }) {
        const closeModal = () => {
            emit("close");
        };

        const handleConfirm = () => {
            emit("transferOpp")
            closeModal()
        }

        // Watch for changes in visibility to apply or remove the backdrop
        watch(
            () => props.isVisible,
            (newValue) => {
                const backdropClass = "modal-backdrop";
                if (newValue) {
                    // Modal is opened
                    document.body.classList.add("modal-open");
                    const backdrop = document.createElement("div");
                    backdrop.className = `${backdropClass} fade show`;
                    document.body.appendChild(backdrop);
                } else {
                    // Modal is closed
                    document.body.classList.remove("modal-open");
                    const backdrop = document.querySelector(`.${backdropClass}`);
                    if (backdrop) {
                        backdrop.remove();
                    }
                }
            }
        );

        // Cleanup on component unmount
        onUnmounted(() => {
            document.body.classList.remove("modal-open");
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
            }
        });

        return {
            closeModal,
            handleConfirm
        };
    },
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed correctly */
}

.row_click {
    cursor: pointer;
}

.table_height {
    max-height: 428px;
}
</style>